import React, {useCallback, useState, useEffect} from 'react';
import SamplesStream from 'track/SamplesStream.js';
import {getSamplesStream} from 'search/getSamplesStream.js';
import {dropSampleTag} from 'utils/dropSampleTag.js';
import { connect } from "react-redux";
import Sample from 'repos/Sample.js';
import {
    setInstrumentTypeDragging,
    setPresetDragging,
    setSampleDragging,
    setSampleTagDragging,
} from 'actions/index.js';

function DropInstrumentHere(props) {
    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (props.instrumentTypeDragging) {
            props.newInstrument(props.instrumentTypeDragging);
            props.setInstrumentTypeDragging(undefined);
        } else if (props.presetDragging) {
            props.newPreset(props.presetDragging);
            props.setPresetDragging(undefined);
        } else if (props.sampleDragging) {
            props.newSample(props.sampleDragging);
            props.setSampleDragging(undefined);
        } else if (props.sampleTagDragging) {
            dropSampleTag(
                props.sampleTagDragging,
                props.track,
                props.setSampleTagDragging,
                props.newSample);
       }
    }, [
        props.instrumentTypeDragging,
        props.newInstrument,
        props.newPreset,
        props.newSample,
        props.presetDragging,
        props.sampleDragging,
        props.sampleTagDragging,
    ]);

    return (
        <div
          onDragOver={(e) => e.preventDefault()}
          onDrop={onDrop}
          className="drop-here">
          <span>
            Drop inst, preset or sample here
          </span>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        instrumentTypeDragging: state.instruments.instrumentTypeDragging,
        presetDragging: state.presets.presetDragging,
        sampleDragging: state.selector.sampleDragging,
        sampleTagDragging: state.selector.sampleTagDragging
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setInstrumentTypeDragging: m => dispatch(setInstrumentTypeDragging(m)),
        setPresetDragging: m => dispatch(setPresetDragging(m)),
        setSampleDragging: m => dispatch(setSampleDragging(m)),
        setSampleTagDragging: m => dispatch(setSampleTagDragging(m)),
    };
};
 
 
export default connect(mapStateToProps, mapDispatchToProps)(DropInstrumentHere);


